import {GameEntity} from "./GameEntity";

export interface NewsItemEntity {
    newsId: string;
    priority: number;
    title: string;
    body: string;
    links: NewsItemLinkEntity[];
    mediaURL: string;
    obj: NewsItemObjEntity;
    game: GameEntity | undefined;
}

export interface NewsItemObjEntity {
    uplayGameId?: number;
    hideIfActivated?: boolean;
    hideIfOwned?: boolean;
    subscriptionType?: string;
}

export interface NewsItemLinkEntity {
    actionName: string;
    param: string;
    type: string;
}

export const NewsItemSubscriptionType = {
    freetrial: "freetrial",
    basic: "basic",
    premium: "premium",
};